<p-dialog #dialog header="Thêm mới danh mục hoa hồng theo dịch vụ" [(visible)]="isShow" [modal]="true"
  [styleClass]="'ag-modal force-full-width'" [style]="{'width': '1200px'}" closeIcon="ci ci-close"
  maximizeIcon="ci ci-maximize" minimizeIcon="ci ci-minimize" [maximizable]="true" [autoZIndex]="true">
  <div class="col-12 md:col-12">
    <form #formElement [formGroup]="formGroup">
      <div class="col-12 md:col-12">
        <validation-summary #validationSummary [formElement]="formElement" [formGroup]="formGroup">
        </validation-summary>
      </div>

      <div class="col-12 md:col-12 p-fluid p-formgrid grid">
        <div class="field col-12 md:col-6">
          <label for="serviceProductCode">Dịch vụ sản phẩm <span style="color: red;">*</span></label>
          <p-dropdown [options]="listServiceProduct" [(ngModel)]="itemDetail.serviceProductCode" [filter]="true" filterBy="label,value"
            [virtualScroll]="true"
            formControlName="serviceProductCode" appendTo="body">
          </p-dropdown>
        </div>
        <div class="field col-12 md:col-6">
          <label for="status">Trạng thái áp dụng <span style="color: red;">*</span></label>
          <p-dropdown [options]="listStatus" [(ngModel)]="itemDetail.status"
            formControlName="status" appendTo="body">
          </p-dropdown>
        </div>
        <div class="field col-12 md:col-6">
          <label for="unitCode">Đơn vị quản lý <span style="color: red;">*</span></label>
          <p-dropdown [options]="listCategoryUnit" [(ngModel)]="itemDetail.unitCode" [filter]="true" filterBy="label,value"
            [virtualScroll]="true"
            formControlName="unitCode" appendTo="body">
          </p-dropdown>
        </div>
        <div class="field col-12 md:col-6"></div>
       
    </div>
    </form>
    <div class="field col-12 md:col-12">
      <p-scrollPanel [style]="{'width': '100%', 'height': '100%'}">
        <p-table [columns]="cols" [paginator]="false" [value]="commissionByCustomerCategories"
          class="ag-table -status-style-border-left" [style]="{'min-width': '1000px'}" [lazy]="true">

          <ng-template pTemplate="header" let-columns>
            <tr>
              <ng-container *ngFor="let col of columns">
                <th *ngIf="col.sort" [hidden]="!col.visible" [pSortableColumn]="col.field">
                  <div class="h-flex-el -h-space-between">
                    <div class="h-overflow-break-word">{{col.header}}</div>
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                  </div>
                </th>
                <th *ngIf="!col.sort" [hidden]="!col.visible">
                  <div class="h-overflow-break-word">{{col.header}}</div>
                </th>
              </ng-container>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-product let-columns="columns" let-rowIndex="rowIndex">
            <tr style="text-align: center">
              <td>
                <p-dropdown appendTo="body" [filter]="true"
                  [autoDisplayFirst]='false' [emptyFilterMessage]="'LIST.EMPTY' | translate" [options]="listCustomerCategory" [virtualScroll]="true"
                  [(ngModel)]="product.customerCategoryCode" [style]="{'width':'100%', 'min-width':'0'}">
                </p-dropdown>
              </td>
              <td>
                <input type="text" pInputText [(ngModel)]="product.commissionRate" autocomplete="off">
              </td>
              <td>
                <button *ngIf="product.action == 'add'" pButton pRipple type="button" icon="pi pi-plus"
                  class="p-button-rounded p-button-text" (click)="onAddCommissionByCustomer(rowIndex)"
                  pTooltip="{{'BUTTON.ADD' | translate }}"></button>
                <button *ngIf="product.action == 'delete'" pButton pRipple type="button" icon="pi pi-trash" class="p-button-rounded p-button-text" style="color: red"
                  (click)="onDeleteCommissionByCustomer(rowIndex)" pTooltip="{{'BUTTON.DELETE' | translate }}"></button>
                <!-- <span *ngSwitchDefault>{{rowData[col.field]}}</span> -->
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-scrollPanel>
    </div>
  </div>
  <p-footer>
    <div class="col-12 md:col-12">
      <div class="col-8 md:col-8 fl h-text-left">
      </div>
      <div class="col-4 md:col-4 fr">
        <button pButton pRipple type="button" label="{{'BUTTON.SAVE_CLOSE' | translate}}" icon="pi pi-save"
          [disabled]="submitting" class="p-button mr-2 mb-2" (click)="saveAndClose()"></button>
<!-- 
        <button pButton pRipple type="button" label="{{'BUTTON.SAVE_CONTINUE' | translate}}" icon="pi pi-save"
          [disabled]="submitting" class="p-button mr-2 mb-2" (click)="save()"></button> -->
      </div>
    </div>
  </p-footer>
</p-dialog>